<template>
    <v-row v-if="!$store.getters.progress" style="height: max-content" class="ma-0" :class="rowClass ?  rowClass : 'pb-offset'">
        <v-col cols="12" class="pa-1">
            <v-card class="pa-0 background-2 round-card" :class="{'elevation-0': inDialog}">
                <v-card-title v-if="!inDialog" class="pa-3">
				    <p class="pl-3">{{ createTitleDialog }}</p>
                    <v-spacer></v-spacer>
                    <QR-scan v-if="modelDef === 'companies'" :model="model"></QR-scan>
                </v-card-title>
                <v-divider v-if="!inDialog"></v-divider>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="mt-2">
                    <fields-generator
                        v-if="loaded"
                        :fieldsset.sync="fieldsset"
                        :model.sync="model"
                        ref="fieldsgenerator"
                        :selectChange="onChange"
                        :support="support"
                        @loaded="checkDefaultInput"
                    ></fields-generator>
                    <small class="px-4">* Indica i campi obbligatori</small>
                </v-container>
            </v-card>
        </v-col>

        <v-col class="pa-1 pt-4" cols="12" v-if="showRelations && crudRelation">
            <crud-table-relationship
                ref="crudTableRelationship"
                :info-url="crudRelation.infoUrl"
                :children="relationModels"
                :parent="model"
                :footer-component="footerComponent"
                :in-dialog="inDialog"
                :totals-config="fieldsset.totals_config"
                :show-history-button="showHistoryDrawer"
                @open-history="openHistoryDrawer"
            ></crud-table-relationship>
        </v-col>

        <v-tooltip top v-if="showSave">
            <template v-slot:activator="{ on: tooltip }">
                <v-fab-transition>
                    <v-btn
                        v-on="{ ...tooltip }"
                        @click.native="createModel"
                        :loading="saved"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab
                        :style="historyFabOffset">
                        <v-icon>check</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Crea</span>
        </v-tooltip>

        <confirm-dialog
			:confirmModel="confirmExit"
			:mainTitle="$trans('save_primary_message')"
			:secondTitle="$trans('save_secondary_message')"
			@update:confirmModel="confirmExit = false"
            :exit="{label:'Esci', color:'error'}"
			:atConfirm="createModel"
			:atExit="exit"
		></confirm-dialog>

		<!-- Chronology Warning Dialog -->
		<chronology-warning-dialog
			v-if="isChronologyEnabled"
			:dialog.sync="chronologyDialog"
			:conflicts="chronologyConflicts"
			@confirm="handleChronologyConfirm"
			@cancel="handleChronologyCancel"
		></chronology-warning-dialog>

        <v-dialog v-model="lockDialog" max-width="600" persistent>
            <v-card class="background-2 round-card">
                <v-card-title primary-title class="subtitle-1 background-2" v-if="lockTitle">{{ lockTitle }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">{{ lockMessage }}</v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native.stop="lockDialog = false">CHIUDI
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Storico prodotti ordinati dal cliente (solo ordini di vendita) -->
        <saleorder-products-history-drawer
            v-if="showHistoryDrawer && historyDrawerOpen"
            :company-id="model.company_id"
            :items="relationModels"
            :add-handler="addProductFromHistory"
            @close="historyDrawerOpen = false"
        ></saleorder-products-history-drawer>
    </v-row>
</template>

<script>
    import Vue from 'vue'
    import FormsMixin from '@/mixins/FormsMixin'
    import documentNumberingValidation from '@/mixins/documentNumberingValidation'
    import QRScan from '@/components/common/QRScan'
    import CrudTableRelationship from '@/components/common/CrudTableRelationship'
    import ChronologyWarningDialog from '@/components/common/ChronologyWarningDialog'
    import SaleorderProductsHistoryDrawer from '@/components/modules/orders/SaleorderProductsHistoryDrawer'

    export default {
        name: 'create',
        mixins: [FormsMixin, documentNumberingValidation],
        components: {
            QRScan,
            CrudTableRelationship,
            ChronologyWarningDialog,
            SaleorderProductsHistoryDrawer
        },
        props: {
            rowClass: String,
            modelDef: String,
            redirect: Object,
            defaultInput: Object,
            urlAppend: {
                type: String,
                default: ''
            },
            queryParams: {
                type: String,
                default: ''
            },
            footerComponent: String,
            showRelations: {
                type: Boolean,
                default: true
            },
            showSave: {
                type: Boolean,
                default: true
            },
            model: {
                type: Object,
                default: function() {
                    return {}
                }
            },
            inDialog: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                fieldsset: {},
                crudRelation: null,
                url: '',
                items: {},
                saved: false,
                relationModels: [],
                historyDrawerOpen: false,
                confirmExit: false,
                support: {},
                loaded: false,
                lockDialog: false,
                lockTitle: null,
                lockMessage: '',
            }
        },

        beforeRouteLeave(to, from, next) {
            if(this.$store.getters.modelEdited) {
                this.confirmExit = true
                this.next = next
            } else {
                next()
            }
        },

        mounted() {
            this.$eventBusUtility.$on('updateQRModel', (parsedResult) => {
                Object.assign(this.model, parsedResult)
                this.model = {...this.model, ...parsedResult}
            })
        },

        created() {

            let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend + '/create' : '/create'
            let queryString = this.queryParams != '' ? '?' + this.queryParams : ''

            this.axios.get(this.modelDef + urlWithAppend + queryString).then(response => {
                // get body data
                this.fieldsset = response.data.fields
                this.crudRelation = response.data.fields.crudRelation
                // Set defaultInput by back-end
                _.forEach(this.fieldsset.fields, (value, key) => {
                    if(value.type === 'file') {
                        Vue.set(this.model, value.key, '')
                    }
                    if(value.type === 'checkbox') {
                        Vue.set(this.model, value.key, false)
                    }
                    
                    if(value.default) {
                        Vue.set(this.model, value.key, value.default)
                    }
                })

                _.forEach(this.defaultInput, (value, key) => {
                    Vue.set(this.model, key, value)
                })

                this.$store.commit('endProgress')

                this.loaded = true

            }, response => {
                    // error callback
            })
        },

        watch: {
            modelForWatcher: {
                handler(newVal, oldVal) {
                    if(!_.isEmpty(oldVal) && !this.$store.getters.progress && (JSON.stringify(newVal) !== JSON.stringify(this.oldVal))) {
                        this.$store.commit('setModelEdited', true)
                    }
                },
                deep: true,
            },
        },

        beforeDestroy() {
            this.$store.commit('setModelEdited', false)
	    },

        computed: {
            // Drawer storico prodotti: solo ordini di vendita, con cliente selezionato
            showHistoryDrawer() {
                return this.modelDef === 'saleorders' && this.showRelations && !!this.crudRelation && !this.inDialog && !!this.model.company_id
            },

            // Su desktop il drawer (permanent, 400px) coprirebbe il FAB: lo sposto a sinistra
            historyFabOffset() {
                if(this.showHistoryDrawer && this.historyDrawerOpen && this.$vuetify.breakpoint.mdAndUp) {
                    return {right: '416px'}
                }
                return {}
            },

            createTitleDialog() {
                if(this.fieldsset) {
                    return Vue.trans('new_' + this.fieldsset.model_name)
                } else {
                    return ''
                }
            },

            modelForWatcher() {
                return _.cloneDeep(this.model);
            },

            isChronologyEnabled() {
                // Extract model type from modelDef
                const modelType = this.extractModelType(this.modelDef)

                if (!modelType) {
                    return false
                }

                // Check if chronology check is enabled for this model type from settings
                const isEnabled = this.$store.getters.getSettingByModel(modelType, 'enable_cronology_check')

                return isEnabled === true || isEnabled === 'true' || isEnabled === 1
            },
        },

        methods: {
            exit() {
                this.$store.commit('setModelEdited', false)
                this.next()
            },

            // Aggiunta rapida dal drawer "Storico prodotti" (ordini di vendita)
            addProductFromHistory(productId, quantity) {
                if(!this.$refs.crudTableRelationship) {
                    return Promise.resolve(false)
                }
                return this.$refs.crudTableRelationship.addProductFromHistory(productId, quantity)
            },

            openHistoryDrawer() {
                this.historyDrawerOpen = true
            },

            // Call at change select option
            onChange(field, event) {
                Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(field, event, this.fieldsset, this.model, this.support, this.defaultInput)).then((responses) => {
                    responses.forEach(response => {
                        if(this.model[response.key]) {
                            this.$refs.fieldsgenerator.$refs[response.key][0].$emit('change', this.model[response.key])
                        }
                    })
                })
            },

            checkDefaultInput() {
                this.$eventBusUtility.checkDefaultInput(this, 'model')
            },

            createModel() {
                // Pulsante bloccato dal primo clic: i controlli prima del salvataggio (lettere d'intento,
                // cronologia) chiamano il server, e ogni clic dato nell'attesa creava un documento in più
                if (this.saved) return
                this.saved = true
                this.confirmExit = false
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        this.saved = false
                        this.$emit('validation-failed')
                        return this.handleValidationErrorAdvanced()
                    }

                    if(this.crudRelation) {
                        this.model[this.crudRelation.relationModelsKey] = this.relationModels.map(({ subtotal, ...rest }) => rest)
                    }

                    // Check chronology before proceeding
                    const proceedWithSave = () => {
                        if(typeof this.fieldsset.checkBeforeSave !== 'undefined' && (typeof this.fieldsset.checkBeforeSave['settings'] == 'undefined' || this.$store.getters.checkSettings(this.fieldsset.checkBeforeSave['settings']))) {
                            this.axios.post(this.fieldsset.checkBeforeSave['url'], this.model).then(response => {
                                // get body data
                                if(response.data.success) {
                                    this.sendModel()
                                } else {
                                    this.saved = false
                                    this.lockTitle = typeof response.data.title != 'undefined' ? response.data.title : null
                                    this.lockMessage = response.data.message
                                    this.lockDialog = true
                                }
                            }, () => {
                                this.saved = false
                            })
                        } else {
                            this.sendModel()
                        }
                    }

                    // Check chronology (from mixin)
                    this.checkChronologyBeforeSave(proceedWithSave)

                }).catch((e) => {
                    this.saved = false
                })
            },

            sendModel() {
                this.saved = true
                let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''
                let queryString = this.queryParams != '' ? '?' + this.queryParams : ''

                this.axios.post(this.modelDef + urlWithAppend + queryString, this.model).then(response => {
                    // get body data
                    this.$emit('update:model', {})
                    this.$eventBusUtility.$emit('modelCreated', response.data.id)

                    // Emit event for document numbering gaps update
                    this.$eventBusUtility.$emit('documentCreated', {
                        modelDef: this.modelDef,
                        id: response.data.id,
                        model: this.model
                    })

                    this.saved = false
                    this.$store.commit('setModelEdited', false)

                    this.$eventBusUtility.chooseRedirect(this.$router, response, this.redirect, this.modelDef)

                }, response => {
                    // error callback
                    this.saved = false
                })
            }
        },
    }
</script>
<style>
</style>